import $ST from 'plugins/tfs/platformConfigs/staticTextMaps/packageOrderList';
import React, { Fragment } from 'react';
import { Row, Col, Select, DatePicker, Input } from 'antd';
import Spinner from 'theme/Spinner';
import { withRouter } from 'react-router-dom';
// pageContainer
import MobileView from '_pageContainers/oms/PackageOrderList/mobileView';

const { Option } = Select;

const MobileViewGrid = (pageContext) => {
  const {
    props,
    selectedDate,
    selectedDeliveryHour,
    statusId,
    packageNumber,
    orderNumber,
    handleStatusChange,
    handleDeliveryDateChange,
    handlePackageNumberChange,
    handleOrderNumberChange,
    handleDeliveryHourChange,
    redirectToDetail,
    rangeFormatter,
  } = pageContext;

  const buildStatusSelectBox = () => {
    const { statuses } = props;

    return (
      <Select
        disabled={statuses.length === 1}
        size='large'
        className='ant-col-xs-24'
        value={statusId}
        onChange={(id) => handleStatusChange(id)}
      >
        {statuses.map((status, index) => {
          const { id, name } = status;
          return (
            <Option key={index} value={id}>
              {name}
            </Option>
          );
        })}
      </Select>
    );
  };

  const { id: deliveryRangeId } = selectedDeliveryHour;
  const {
    deliveryRanges,
    packageOrders,
    packageOrderCount,
    pendings: { pendingPackageStatuses, pendingPackageOrders },
  } = props;

  if (pendingPackageStatuses) return <Spinner centerOfPage />;

  return (
    <div className='ant-col-xs-24 package-order-list-mobile'>
      <p className='bold'>{$ST.ORDER_PACKAGE_STATUS}</p>
      <div className='ant-col-xs-24 mb30'>{buildStatusSelectBox()}</div>
      <div className='ant-col-xs-24 mb30'>
        <div className='picker-container'>
          <div className='first-col'>
            <p className='bold'>{$ST.DELIVERY_DATE}</p>
            <DatePicker
              value={selectedDate}
              size='large'
              className='full-width'
              placeholder={$ST.SELECT_DATE}
              format='DD.MM.YYYY dddd'
              onChange={(date) => handleDeliveryDateChange(date)}
              showToday={false}
            />
          </div>
          <div className='second-col'>
            <p className='bold'>{$ST.DELIVERY_HOUR}</p>
            <Select
              size='large'
              className='ant-col-xs-24'
              placeholder={$ST.SELECT_DELIVERY_HOUR}
              value={deliveryRangeId}
              onChange={handleDeliveryHourChange}
            >
              {deliveryRanges.map((deliveryRange, index) => {
                const { id } = deliveryRange;
                return (
                  <Option key={index} value={id}>
                    {rangeFormatter(deliveryRange)}
                  </Option>
                );
              })}
            </Select>
          </div>
        </div>
      </div>
      <div className='ant-col-xs-12 mb30 pr15'>
        <p className='bold'>{$ST.FILTERS.PACKAGE_NUMBER}</p>
        <Input value={packageNumber} onChange={handlePackageNumberChange} />
      </div>
      <div className='ant-col-xs-12 mb30'>
        <p className='bold'>{$ST.FILTERS.ORDER_NUMBER}</p>
        <Input value={orderNumber} onChange={handleOrderNumberChange} />
      </div>
      {!pendingPackageOrders && (
        <Fragment>
          {packageOrderCount !== null && packageOrderCount > 0 && (
            <p className='ant-col-xs-24 output-date font24 mb25'>
              {$ST.COUNT_OF_PACKAGES}: {packageOrderCount}
            </p>
          )}
          {packageOrderCount !== null && packageOrderCount > 0 && (
            <p className='ant-col-xs-24 bold'>{$ST.ORDER_PACKAGES}</p>
          )}
          {packageOrders.map((packageOrder, index) => {
            const {
              id,
              number,
              packageItemSet = [],
              shippingAddress: {
                customerName,
                customerSurname,
                phone,
                district,
                line,
                township,
                city,
              },
              deliveryRange,
            } = packageOrder;
            const packageCount = packageItemSet.length;
            return (
              <div
                key={index}
                onClick={() => redirectToDetail(id)}
                className='ant-col-xs-24 card pointer'
              >
                <div className='ant-col-xs-24'>
                  <Row>
                    <Col>
                      <p className='ant-col-xs-12 package-number'>{number}</p>
                    </Col>
                    <Col align='right'>
                      <p className='ant-col-xs-12 hour-range'>
                        {rangeFormatter(deliveryRange)}
                      </p>
                    </Col>
                  </Row>
                  <Row>
                    <p>
                      {`${packageCount}` || '0'} {$ST.PRODUCT}
                    </p>
                  </Row>
                  <Row align='bottom'>
                    <p>{`${customerName} ${customerSurname}`}</p>
                    <p>{phone}</p>
                    <p>{district}</p>
                    <p>{line}</p>
                    <p className='mb0'>{`${township} / ${city}`}</p>
                  </Row>
                </div>
              </div>
            );
          })}
          {!packageOrders.length && packageOrderCount !== null && (
            <div className='ant-col-xs-24 center'>
              <p className='large'>{$ST.PACKAGE_NOT_FOUND}</p>
            </div>
          )}
        </Fragment>
      )}
      {pendingPackageOrders && <Spinner centerOfPage />}
    </div>
  );
};

export default withRouter(MobileView(MobileViewGrid));



// WEBPACK FOOTER //
// ./src/plugins/tfs/pages/oms/PackageOrderList/mobileView/index.js